import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { IAssetModelDto } from '~/models/modules/Asset/assetModel';
import { IUPCBarcodes } from '~/models/modules/upcBarcodes';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({
  providedIn: 'root'
})
export class AssetModelService extends ApiServiceBase {

  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.assets);
  }
  assetModelAdded: EventEmitter<any> = new EventEmitter();
  assetModelUpdated: EventEmitter<any> = new EventEmitter();
  getAssetModelGrid(paramsObj?: any, model?: any, screenSiteId? : number) {
    paramsObj = paramsObj || {};
    paramsObj.screenSiteId = screenSiteId;
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
        .post<any[]>(this._url(`/grid-data`), model, {
            params,
            observe: 'response',
        })
        .pipe(map(augmentPaging));
  }

  getAssetModelListing(paramsObj?:any, screenSiteId? : number, accountIds? : any){
    paramsObj = paramsObj || {};
    paramsObj.screenSiteId = screenSiteId;
    paramsObj.accountIds = accountIds;
    let params = createHttpParams(paramsObj);
    return this.http.get<IAssetModelDto[]>(this._url(),{
      params,
      observe:'response',
    });
  }
  getAssetModelById(id:number){
    return this.client.get<IAssetModelDto>(this._url(`/${id}`))
  }
  createAssetModel(model : any){
    return this.client.post<any>(this._url(), model);
  }
  updateAssetType(id: number, model : any){
    return this.client.post<any>(this._url(`/${id}`), model);
  }
  deactivateModel(obj: any) {
    return this.client.put(this._url(`/deactivate`), obj);
  }
  deactivateModelBatch(obj: any) {
    return this.client.put(this._url(`/batchDeactivate`), obj);
  }
  reactivateModel(id: number) {
    return this.client.post<any>(this._url(`/reactivate/${id}`), null);
  }
  reactivateModelBatch(obj: any) {
    return this.client.put(this._url(`/batchReactivate`), obj);
  }
  upcSearch(modelNumber:string){
    return this.client.get<IUPCBarcodes[]>(this._url(`/upc-search/${modelNumber}`))
  }
  getSiteModels(siteId:number){
    return this.client.get<IAssetModelDto[]>(this._url(`/getsitemodels/${siteId}`));
  }
  getAssetModelRange(ids:number[]){
    return this.client.post<IAssetModelDto[]>(this._url(`/range`), ids);
  }
  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/Models${v}`);
  }
}
